import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from '../common/consts/kentico';

class EnterpriseService {
  async fetchEnterprises() {
    return Client.items()
      .type(KENTICO_TYPES.ENTERPRISE)
      .toPromise();
  }
}

export default new EnterpriseService();



// WEBPACK FOOTER //
// ./src/services/Enterprises.service.js